import * as angular from 'angular';
import { RegentsExamsStepperTransferModule } from './components/regents-exams-stepper-transfer/regents-exams-stepper-transfer.module';
import { RegentsPrepWizardTransferComponent } from './regents-prep-wizard-transfer.component';

export const RegentsPrepWizardTransferModule = angular
  .module('regentsPrepWizardTransferModule', [RegentsExamsStepperTransferModule])
  .component('regentsPrepWizardTransfer', RegentsPrepWizardTransferComponent).name;
